import React from 'react'
import { useTranslation } from 'react-i18next'
import porphile from '../assets/Lean.jpeg'
import Tilt from 'react-vanilla-tilt';

const Card = (props) => {
    const [t] = useTranslation("global");
    return ( 
    <Tilt style={{width:'1200px',borderRadius:'20px'}}>
        <div>
        <div className='Card-Container'>
        <div style={{paddingBottom:'20px',textAlign:'start'}}>
            <div className="container">
                <div>
                    <h2 style={{paddingBottom:'10px'}}>{t("Professional_profile")}</h2>
                    <p style={{textAlign:"start"}}>{t("ph1")}</p>
                    <br />
                    <div style={{paddingBottom:'20px'}}>
                    <h2 style={{paddingBottom:'10px'}}>{t("Work_Experience")}</h2>
                    <p style={{textAlign:"start"}}>{t("ph2")}</p>
                    <br />
                    <p style={{textAlign:"start"}}>{t("ph3")}</p>
                </div>
                    <div style={{paddingBottom:'20px'}}>
                    <h2 style={{paddingBottom:'10px'}}>{t("Education")}</h2>
                    <ul className='Card-FullList'>
                        <li className='Card-item'>{t("it1")}</li>
                        <li className='Card-item'>{t("it2")}</li>
                        <li className='Card-item'>{t("it3")}</li>
                        <li className='Card-item'>{t("it4")}</li>
                        <li className='Card-item'>{t("it5")}</li>
                    </ul>
                    </div>
                </div>
                <img src={porphile} alt='porphile' className='Porphile-img' />
            </div>
        </div>
        </div>
        </div>
    </Tilt>
    )
}

export default Card
